import React from "react";
import { MyTimeLine } from "../../components/MyTimeLine";
import { MyColor } from "../../config/myStyle";
import { top_tool_bar_foodangel_logo } from "../../imgs";
import { useNavigate } from "react-router-dom";
import PageBox from "../../layout/PageBox";
import { useTranslation } from "react-i18next";

const RegisterSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageBox spinning={false}>
      <div style={{ padding: 18 }}>
        <div className="text-[32px] font-[400]" style={{ color: MyColor.blue }}>
          {t("register_success.title")}
        </div>
        <MyTimeLine className="pb-[24px] pt-[15px]" current={2} steps={2} />
        <div
          style={{
            background: "white",
            borderRadius: 20,
            padding: "32px 20px 16px 20px",
            marginTop: 8,
            marginBottom: 16,
          }}
        >
          {/* 顶部小icon */}
          <div style={{ textAlign: "left", marginBottom: 16 }}>
            <span
              style={{
                fontSize: 32,
                verticalAlign: "middle",
                marginRight: 6,
                color: "#f25d7a",
                display: "inline-block",
                lineHeight: "32px"
              }}
            >💚</span>
          </div>

          <div
            style={{
              fontSize: 18,
              fontWeight: 500,
              color: MyColor.blue,
              marginBottom: 14,
              textAlign: 'center',
            }}
          >
            {t("register_success.thanks")}
          </div>

          <div
            style={{
              fontSize: 14,
              color: "#555",
              marginBottom: 10,
              textAlign: "left",
              opacity: 0.7,
            }}
          >
            {t("register_success.support_message")}
          </div>

          <div
            style={{
              fontSize: 14,
              color: "#555",
              marginBottom: 10,
              opacity: 0.7,
              textAlign: "left"
            }}
          >
            {t("register_success.contact_message")}
          </div>

          {/* LOGO */}
          <div
            onClick={() => navigate('/')}
            style={{
              textAlign: "center", marginTop: 55, marginBottom: 35,
            }}>
            <img
              src={top_tool_bar_foodangel_logo}
              alt="Food Angel"
              style={{ height: 80, margin: "0 auto" }}

            />
          </div>
        </div>
      </div>
    </PageBox>
  );
};

export default RegisterSuccess;
